<template>
  <Row>
    <Col span="24">
    <img src="../../../assets/banner@2x.png" alt="" style="width:100%;display:block" />
    </Col>
  </Row>
</template>
<script>
export default {}
</script>
<style lang="less" scoped></style>



// WEBPACK FOOTER //
// src/views/home/components/adPic.vue